var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttunewise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6396663c-3d61-452d-833c-1b5fc2e3e893",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-d0fd98ce-5580-4104-93a0-fd95506f8c79 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-376f7c73-2a0f-4ad5-a005-09ec23b8a260",
    "data-name": "Path 1",
    className: "uuid-d0fd98ce-5580-4104-93a0-fd95506f8c79",
    d: "M23.68,19.5l-5.48-9.55c-.7-1.22-2.26-1.64-3.47-.93-.39.22-.71.55-.93.93l-5.48,9.55c-.7,1.22-.29,2.78.93,3.49.39.22.83.34,1.27.34h10.97c1.4,0,2.54-1.14,2.54-2.55,0-.45-.12-.89-.34-1.28M16,21.52c-2.16,0-3.91-1.76-3.91-3.93s1.75-3.93,3.91-3.93,3.91,1.76,3.91,3.93-1.75,3.93-3.91,3.93h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-ee9d9fd0-b3b3-4a0a-ae72-5853a4b6d03b",
    "data-name": "Path 2",
    className: "uuid-d0fd98ce-5580-4104-93a0-fd95506f8c79",
    d: "M18.57,19.08l-.7-1.22c.15-1.04-.56-2.01-1.6-2.16-1.04-.15-2,.57-2.15,1.61s.56,2.01,1.6,2.16c.52.08,1.04-.06,1.45-.39h1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttunewise);
export default __webpack_public_path__ + "static/media/Attunewise.816704a35e088300a54f1d19c4d56696.svg";
export { ForwardRef as ReactComponent };